import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';

export interface ISalaryScaleGroup extends BaseEntity {
    id: string;
    name: string;
    description: string;
    isDefaultNmbrsCao?: boolean;
    /** Gelijkwaardige beloning bruto als percentage van het uurloon (0–100); factuur en Nmbrs. */
    grossWageAllowancePercentage?: number;
    /** Omrekenfactor op het berekende gelijkwaardige-beloning-bruto bedrag; standaard 1. */
    grossWageAllowanceConversionFactor?: number;
    enableSleepShiftOrtRules?: boolean;
    /** ORT-aftopping: toeslag begrensd op uurloon van de plafond-loonschaal. */
    enableOrtCap?: boolean;
    /** Plafond-loonschaal binnen deze CAO (bijv. schaal 5-11). */
    ortCapSalaryScaleId?: string;
    salaryScales?: ISalaryScale[];
}

export interface ISalaryScale extends BaseEntity {
    id: string;
    salaryScaleGroupId: string;
    code: string;
    name: string;
    hourlyWage: number;
    conversionFactor: number;
}

export class SalaryScaleGroupService extends BaseService<ISalaryScaleGroup> {
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'hr/salaryscalegroup');
    }
}

export class SalaryScaleService extends BaseService<ISalaryScale> {
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'hr/salaryscale');
    }

    public getBySalaryScaleGroupId = (salaryScaleGroupId: string): ng.IPromise<ISalaryScale[]> => {
        return this.Restangular.one(this.itemName + '/group/' + salaryScaleGroupId).get().then((response: any) => {
            if (response && typeof response !== "string" && response.plain) {
                return response.plain();
            }
            return response;
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/services/salaryScaleGroup.service.ts